import { lazy } from "react";
import { Route } from "react-router-dom";

import UserRoute from "../components/Routes/UserRoute";
import {
  CardsPageSkeleton,
  FormSkeleton,
  ListingDetailsSkeleton,
  ProfileSkeleton,
} from "../components/ui/Skeleton";

const cards = <CardsPageSkeleton />;

const UserProfile = lazy(() => import("../components/User/UserProfile"));
const UpdateProfile = lazy(() => import("../components/User/UpdateProfile"));
const ChangePassword = lazy(() => import("../components/User/ChangePassword"));

const PropertyAddress = lazy(() =>
  import("../components/SubmitListing/PropertyAddress")
);
const PropertyDetails = lazy(() =>
  import("../components/SubmitListing/PropertyDetails")
);
const ImagesAndNewListing = lazy(() =>
  import("../components/SubmitListing/ImagesAndNewListing")
);

const UpdatePropertyAddress = lazy(() =>
  import("../components/UpdateListing/UpdatePropertyAddress")
);
const UpdatePropertyDetails = lazy(() =>
  import("../components/UpdateListing/UpdatePropertyDetails")
);
const UpdateImagesAndNewListing = lazy(() =>
  import("../components/UpdateListing/UpdateImagesAndNewListing")
);

const UserManageProperties = lazy(() =>
  import("../pages/user/ManageProperties")
);
const UserLikedListings = lazy(() => import("../pages/user/LikedListings"));
const UserListingDetailsPage = lazy(() =>
  import("../components/User/UserListingDetailsPage")
);
const DeactivateAccountUser = lazy(() =>
  import("../components/User/DeactivateAccountUser")
);
const UserCanNotPost = lazy(() => import("../pages/user/UserCanNotPost"));

// User-only routes (rendered when a `state.user.role === "user"` session is
// active). The <UserRoute> guard renders <Navigate to="/users/login"> for
// unauthenticated visitors.
const UserRoutes = () => (
  <>
    <Route path="/user/:username" element={<UserRoute fallback={<ProfileSkeleton />}><UserProfile /></UserRoute>} />
    <Route path="/user/settings/profile" element={<UserRoute fallback={<FormSkeleton fields={6} narrow={false} />}><UpdateProfile /></UserRoute>} />
    <Route path="/user/settings/change-password" element={<UserRoute fallback={<FormSkeleton />}><ChangePassword /></UserRoute>} />

    <Route path="/create-listing/property-address" element={<UserRoute><PropertyAddress /></UserRoute>} />
    <Route path="/create-listing/property-details" element={<UserRoute><PropertyDetails /></UserRoute>} />
    <Route path="/create-listing/ui/submit" element={<UserRoute><ImagesAndNewListing /></UserRoute>} />

    <Route path="/update-listing/property-address/:id" element={<UserRoute><UpdatePropertyAddress /></UserRoute>} />
    <Route path="/update-listing/property-details/:id" element={<UserRoute><UpdatePropertyDetails /></UserRoute>} />
    <Route path="/update-listing/ui/submit/:id" element={<UserRoute><UpdateImagesAndNewListing /></UserRoute>} />

    <Route path="/user/listings/:currentPage" element={<UserRoute fallback={cards}><UserManageProperties /></UserRoute>} />
    <Route path="/user/liked-listings/:currentPage" element={<UserRoute fallback={cards}><UserLikedListings /></UserRoute>} />
    <Route path="/my/property-details/:slug/:id" element={<UserRoute fallback={<ListingDetailsSkeleton />}><UserListingDetailsPage /></UserRoute>} />
    <Route path="/user/settings/deactivate" element={<UserRoute fallback={<FormSkeleton fields={1} />}><DeactivateAccountUser /></UserRoute>} />
    <Route path="/action-unavailable" element={<UserRoute><UserCanNotPost /></UserRoute>} />
  </>
);

export default UserRoutes;
